<!--
 * @Author: M.D.
 * @Date: 2019-12-12 15:40:49
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="index-sec">
    <div class="s-left">
      <span class="m">{{mTitle}}</span>
      <span class="s">{{sTitle}}</span>
      <!--<span v-if="needMore" class="t" @click="goMore"> 更多 ></span>-->
    </div>
    <div v-if="needMore" class="s-right" @click="goMore">
      更多 >
    </div>
  </div>
</template>

<script>

export default {
  props: {
    mTitle: {
      type: String,
      default: '主标题'
    },
    sTitle: {
      type: String,
      default: '副标题'
    },
    moreLinkName: {
      type: String,
      default: 'news'
    },
    needMore: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  activated () {

  },
  deactivated () {

  },
  watch: {

  },
  methods: {
    goMore () {
      this.$router.push({ name: this.moreLinkName })
    }
  },
  components: {

  }
}
</script>

<style lang="stylus" scope>

.index-sec
  height 100px
  flex-ltr-parent()
  // background-color yellow
  .s-left
    flex-left()
    .m
      font-size 24px
      color #333333
      margin-top 16px
      padding-bottom 16px
      letter-spacing 2px
      border-bottom 2px solid theme-color
    .s
      margin-left 14px
      font-size 12px
      color #666666
      font-weight bold
    .t
     //margin-left 200px
     text-align  right
     font-size 19px
     color #996666
     font-weight bold
  .s-right
    flex-right()
    font-size 15px
    color #999999
</style>
